import sendEventToCounters from '@/src/counterEvents';
import { MutableRefObject } from 'react';
import ReactPlayer from 'react-player';

type TProps = {
  videoRef: MutableRefObject<ReactPlayer | null>;
};

export const SkipButton = ({ videoRef }: TProps) => {
  const handleClick = () => {
    const video = videoRef.current;

    if (video) {
      video.seekTo(0.95, 'fraction');
    }

    sendEventToCounters({ action: 'button', label: 'skip' });
  };

  return (
    <button className="btn_choice btn_control" onClick={handleClick}>
      Пропустить ролик
    </button>
  );
};
